import Cookies from "js-cookie";

export default class Disclaimer {

	static init() {
		return new Disclaimer();
	}

	constructor() {
		const disclaimer = document.querySelector('.modal.disclaimer');
		if (!disclaimer)
			return;

		const buttonQualified = disclaimer.querySelector('.button-primary');

		buttonQualified.addEventListener('click', (e) => {
			e.preventDefault();
			Cookies.set('disclaimer_accepted', true, { expires: 365 });
		});
	}
}
